<script setup lang="ts">
const route = useRoute()
const renderMobileContent = computed(() => import.meta.dev || route.meta.mobileReady === true)

const isAboutBookPath = useIsAboutBookPath()
</script>

<template>
  <LayoutContainer>
    <template v-if="renderMobileContent">
      <Header />
      <main class="flex-1">
        <slot />
      </main>
      <Footer v-if="isAboutBookPath" :class="{ 'dark-mode': route.meta.footerVariant === 'dark' }" />
    </template>

    <template v-else>
      <div class="hidden md:contents">
        <Header />
        <main class="flex-1">
          <slot />
        </main>
        <Footer v-if="isAboutBookPath" :class="{ 'dark-mode': route.meta.footerVariant === 'dark' }" />
      </div>

      <div class="md:hidden">
        <div class="flex items-center gap-x-xl justify-between w-full py-l px-m">
          <NavLogo class="z-10" />
        </div>
        <div class="fixed top-0 h-dvh flex items-center justify-center bg-carbon-50 -mt-10">
          <div class="text-center px-6">
            <h2 class="title-xl mb-4">
              Mobilsidene er dessverre ikke klare
            </h2>
            <p class="font-light text-center leading-5 text-lg mb-4">
              Prøv nye Juridika på desktop i første omgang
            </p>
          </div>
        </div>
        <div class="fixed -bottom-8 left-1/2 transform -translate-x-1/2 w-[400px] h-[300px] z-10">
          <IllustrationHus class="w-full h-full" />
        </div>
      </div>
    </template>
  </LayoutContainer>
</template>
